module.exports = __webpack_public_path__ + "img/reviewsInfo.afcab93c.svg";